import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appScrolling]',
    standalone: false
})
export class ScrollingDirective {

  private parentElement!: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    // Get the parent element of the host
    this.parentElement = this.el.nativeElement.parentElement;

    // Add event listener to the parent element
    this.parentElement.addEventListener('scroll', this.onParentScroll);
  }

  ngOnDestroy() {
    // Clean up the event listener to avoid memory leaks
    if (this.parentElement) {
      this.parentElement.removeEventListener('scroll', this.onParentScroll);
    }
  }

  private onParentScroll = () => {
    const scrollTop = this.parentElement.scrollTop;

    // Add or remove the 'scrolled' class based on the scroll position
    if (scrollTop > 0) {
      this.renderer.addClass(this.el.nativeElement, 'scrolled');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'scrolled');
    }
  };
}
